<div class="header">
  <div class="title">{{ "contract" | translate }}</div>
</div>

<div class="content">
  <form [formGroup]="searchForm">
    <mat-form-field floatLabel="always" [subscriptSizing]="'dynamic'">
      <mat-label>{{ "contracts.labels.contractNumber" | translate }}</mat-label>
      <input matInput value="" formControlName="contractNumber" [matAutocomplete]="autoNumber" />
      <mat-autocomplete #autoNumber="matAutocomplete">
        @for (contractNumber of contractNumberList | async; track $index) {
          <mat-option [value]="contractNumber">
            {{ contractNumber }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <div class="section-title">{{ "contracts.labels.startDate" | translate }}</div>

    <mat-form-field floatLabel="always" [subscriptSizing]="'dynamic'">
      <mat-label>{{ "from" | translate }}</mat-label>
      <input matInput [matDatepicker]="pickerStartFrom" formControlName="startFrom" />
      <mat-datepicker-toggle matIconSuffix [for]="pickerStartFrom"></mat-datepicker-toggle>
      <mat-datepicker #pickerStartFrom></mat-datepicker>
    </mat-form-field>
    <mat-form-field floatLabel="always" [subscriptSizing]="'dynamic'">
      <mat-label>{{ "to" | translate }}</mat-label>
      <input matInput [matDatepicker]="pickerStartTo" formControlName="startTo" />
      <mat-datepicker-toggle matIconSuffix [for]="pickerStartTo"></mat-datepicker-toggle>
      <mat-datepicker #pickerStartTo></mat-datepicker>
    </mat-form-field>

    <div class="section-title">{{ "contracts.labels.endDate" | translate }}</div>

    <mat-form-field floatLabel="always" [subscriptSizing]="'dynamic'">
      <mat-label>{{ "from" | translate }}</mat-label>
      <input matInput [matDatepicker]="pickerEndFrom" formControlName="endFrom" />
      <mat-datepicker-toggle matIconSuffix [for]="pickerEndFrom"></mat-datepicker-toggle>
      <mat-datepicker #pickerEndFrom></mat-datepicker>
    </mat-form-field>
    <mat-form-field floatLabel="always" [subscriptSizing]="'dynamic'">
      <mat-label>{{ "to" | translate }}</mat-label>
      <input matInput [matDatepicker]="pickerEndTo" formControlName="endTo" />
      <mat-datepicker-toggle matIconSuffix [for]="pickerEndTo"></mat-datepicker-toggle>
      <mat-datepicker #pickerEndTo></mat-datepicker>
    </mat-form-field>

    <div class="section-title">Aircraft</div>

    <mat-form-field floatLabel="always" [subscriptSizing]="'dynamic'">
      <mat-label>{{ "products.labels.commercialName" | translate }}</mat-label>
      <mat-select formControlName="aircraftTechnicalName" (selectionChange)="updateSelectedAircraft($event.value)">
        <mat-option>All</mat-option>
        @for (aircraft of searchData?.aircrafts; track $index) {
          <mat-option [value]="aircraft.commercialName">
            {{ aircraft.commercialName }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field floatLabel="always" [subscriptSizing]="'dynamic'">
      <mat-label>{{ "products.labels.aircraftVersion" | translate }}</mat-label>
      <mat-select formControlName="aircraftVersion">
        <mat-option>All</mat-option>
        @for (version of selectedAircraft?.version; track $index) {
          <mat-option [value]="version">
            {{ version }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field floatLabel="always" [subscriptSizing]="'dynamic'">
      <mat-label>{{ "products.labels.manualCode" | translate }}</mat-label>
      <mat-select formControlName="manualCode">
        <mat-option>All</mat-option>
        @for (productType of searchData?.productType; track $index) {
          <mat-option [value]="productType">
            {{ productType }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field floatLabel="always" [subscriptSizing]="'dynamic'">
      <mat-label>{{ "products.labels.lang" | translate }}</mat-label>
      <mat-select formControlName="langCode">
        <mat-option>All</mat-option>
        @for (language of searchData?.language; track $index) {
          <mat-option [value]="language">
            {{ language }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field floatLabel="always" [subscriptSizing]="'dynamic'">
      <mat-label>{{ "products.labels.custom" | translate }}</mat-label>
      <input matInput value="" formControlName="customizationCode" [matAutocomplete]="autoCustom" />
      <mat-autocomplete #autoCustom="matAutocomplete">
        @for (custom of customizationList | async; track $index) {
          <mat-option [value]="custom">
            {{ custom }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field floatLabel="always" [subscriptSizing]="'dynamic'">
      <mat-label>{{ "products.labels.booklet" | translate }}</mat-label>
      <input matInput value="" formControlName="booklet" [matAutocomplete]="autoBooklet" />
      <mat-autocomplete #autoBooklet="matAutocomplete">
        @for (booklet of bookletList | async; track $index) {
          <mat-option [value]="booklet">
            {{ booklet }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </form>

  <div class="footer">
    <button mat-raised-button (click)="reset()">
      {{ "button.reset" | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="submit()" [disabled]="!searchForm.valid">
      {{ "button.search" | translate }}
    </button>
  </div>
</div>
